import { Skeleton } from "@/components/ui/skeleton";

/** The page's content area while a route loads: a title and a few blocks, so the page is never blank. */
export const ContentSkeleton = () => (
  <div className="ernest-container py-6 pt-10" aria-busy="true" aria-label="Loading">
    <Skeleton className="h-8 w-64" />
    <Skeleton className="mt-3 h-4 w-96 max-w-full" />
    <div className="mt-8 grid grid-cols-2 gap-4 lg:grid-cols-4">
      {[0, 1, 2, 3].map((i) => <Skeleton key={i} className="h-24 rounded-xl" />)}
    </div>
    <Skeleton className="mt-6 h-64 rounded-xl" />
  </div>
);

/** The whole app while it checks who you are: the sidebar's outline and the content skeleton. */
const AppShellSkeleton = () => (
  <div className="flex min-h-screen bg-background">
    <aside className="fixed bottom-0 left-0 top-0 flex w-36 flex-col items-center border-r border-border bg-sidebar px-3 pt-10" aria-hidden>
      <Skeleton className="h-7 w-24" />
      <Skeleton className="mt-8 h-[44px] w-[44px] rounded-lg" />
      <Skeleton className="mt-2 h-3 w-16" />
      {/* Same shape as the sidebar: two items, a divider, then Campaigns and the four formats */}
      <div className="mt-9 flex w-full flex-col items-center gap-1.5">
        {[0, 1].map((i) => (
          <div key={i} className="flex flex-col items-center gap-1 py-1">
            <Skeleton className="h-[30px] w-[30px] rounded-md" />
            <Skeleton className="h-3 w-14" />
          </div>
        ))}
        <div className="mx-1 mb-1 mt-3 h-px w-full bg-border" aria-hidden />
        {[0, 1, 2, 3, 4].map((i) => (
          <div key={i} className="flex flex-col items-center gap-1 py-1">
            <Skeleton className="h-[30px] w-[30px] rounded-md" />
            <Skeleton className="h-3 w-14" />
          </div>
        ))}
      </div>
    </aside>
    <div className="ml-36 min-h-screen min-w-0 flex-1">
      <ContentSkeleton />
    </div>
  </div>
);

export default AppShellSkeleton;
